import { render, staticRenderFns } from "./AccountStep.vue?vue&type=template&id=85229afe&scoped=true&lang=pug&"
import script from "./AccountStep.vue?vue&type=script&lang=js&"
export * from "./AccountStep.vue?vue&type=script&lang=js&"
import style0 from "./AccountStep.vue?vue&type=style&index=0&id=85229afe&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85229afe",
  null
  
)

export default component.exports